(function TripSummarySelectComponentTravelers($, Adzuki)
{
	'use strict';

	const component = {
		inject: [
			'getFaIconStyle',
		],
		props: {
			formId: {
				type    : String,
				required: true,
			},
			formName: {
				type    : String,
				required: true,
			},
			componentTravelers: {
				type    : Array,
				required: true,
			},
		},
		template: '#ts-select-component-travelers',
		data() {
			return {
				travelers    : [],
				showTravelers: true,
			};
		},
		watch: {
			showTravelers: {
				handler(newValue, oldValue) {
					// select all travelers if we are checking the show travelers checkbox
					if (oldValue === false && newValue === true) {
						this.travelers.forEach(traveler => {
							traveler.selected = true;
						});
					}
				},
			},
		},
		mounted() {
			this.travelers = this.componentTravelers;

			// if there are no travelers selected, hide them
			if (this.travelers.every(traveler => !traveler.selected)) {
				this.showTravelers = false;
			}
		},
	};

	Adzuki.VueComponents.TripSummarySelectComponentTravelers = component;
}(jQuery, window.Adzuki || {}));
